import { createContext } from "react"
import { PeriodType, PeriodTypeQuery, PeriodTypeView } from "@/types"

export type TableContextValue = {
  lastHistoricalPeriod: string | null
  view: PeriodTypeView
  queryPeriod: PeriodTypeQuery
  period?: PeriodType
  readonly?: boolean
}

const TableContext = createContext<TableContextValue>({
  lastHistoricalPeriod: null,
  view: `monthly`,
  queryPeriod: `all`,
  period: `historical`,
  readonly: false,
})

const TableProvider = TableContext.Provider

export type TableRowType =
  | `input`
  | `output`
  | `totals`
  | "total-input"
  | "totals-dark"
  | "totals-white"

const TableRowContext = createContext<{
  type: TableRowType
}>({
  type: `output`,
})

const TableRowProvider = TableRowContext.Provider

export { TableContext, TableProvider, TableRowContext, TableRowProvider }
